export function setCaptchaEuScript() {
    const mountedCaptchaEuScript = document.querySelector(
        'script[src="https://w19.captcha.at/sdk.js"]',
    );
    if (mountedCaptchaEuScript) return;

    const captchaEuScript = document.createElement('script');
    captchaEuScript.setAttribute('src', 'https://w19.captcha.at/sdk.js');
    captchaEuScript.setAttribute('type', 'text/javascript');
    document.body.appendChild(captchaEuScript);
}
